/**
 * Enum for unit visibility states
 * @readonly
 * @enum {string|boolean}
 */
export const UnitsVisibility = {
    /** No units are visible */
    NONE: false,
    /** All units are visible */
    ALL: 'all',
    /** Only units in selected area are visible */
    AREA: 'area'
};

/**
 * Type guard to check if a value is a valid UnitsVisibility state
 * @param {any} value - The value to check
 * @returns {boolean} True if the value is a valid UnitsVisibility state
 */
export const isValidUnitsVisibility = (value) => {
    return Object.values(UnitsVisibility).includes(value);
};

export default UnitsVisibility; 